"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _chunkV767VWABjs = require("./chunk-V767VWAB.js");
var _chunkYULSKELGjs = require("./chunk-YULSKELG.js");
// src/utils/string-validators.ts
var StringValidator = /*#__PURE__*/ function() {
    function _StringValidator() {
        _class_call_check(this, _StringValidator);
    }
    _create_class(_StringValidator, null, [
        {
            key: "validateNullOrUndefined",
            value: /**
   * Validate if a string is defined .
   *
   * string str - The string to be validated.
   * @throws UndefinedOrNullError - Thrown when an argument is undefined or null.
   *
   */ function validateNullOrUndefined(str, key) {
                if (str === null) {
                    throw new (0, _chunkV767VWABjs.UndefinedOrNullError)(_chunkYULSKELGjs.errorMessages.UNDEFINED_PROPERTY + key);
                }
                if (str === void 0) {
                    throw new (0, _chunkV767VWABjs.UndefinedOrNullError)(_chunkYULSKELGjs.errorMessages.UNDEFINED_PROPERTY + key);
                }
            }
        },
        {
            key: "validateString",
            value: /**
   * Validate if a string is typed .
   *
   * string str - The string to be validated.
   * @throws InvalidStringError - Thrown when an argument not a string.
   *
   */ function validateString(str, key) {
                if (typeof str !== "string") {
                    throw new (0, _chunkV767VWABjs.InvalidStringError)(_chunkYULSKELGjs.errorMessages.INVALID_STRING + key);
                }
            }
        },
        {
            key: "validateEmptyString",
            value: /**
   * Validate if the string length is grater than 0.
   *
   * string str - The string to be validated.
   * @throws EmptyStringError - Thrown when the argument length equal to 0.
   *
   */ function validateEmptyString(str, key) {
                if (str.length === 0) {
                    throw new (0, _chunkV767VWABjs.EmptyStringError)(_chunkYULSKELGjs.errorMessages.EMPTY_STRING + key);
                }
            }
        },
        {
            key: "validateUrl",
            value: /**
   * Validate if the url is valid.
   *
   * string str - The string to be validated.
   * @throws InvalidUrlError - Thrown when the URL is invalid.
   *
   */ function validateUrl(url) {
                var validUrlRegex = /^(?:http|https):\/\/[^\s$.?#].[^\s]*$/;
                if (!validUrlRegex.test(url)) {
                    throw new (0, _chunkV767VWABjs.InvalidUrlError)(_chunkYULSKELGjs.errorMessages.INVALID_URL);
                }
            }
        },
        {
            key: "validateStringValue",
            value: /**
   * Validate the string value for an object
   *
   * string value - The value to be validated.
   */ function validateStringValue(value, key) {
                _StringValidator.validateNullOrUndefined(value, key);
                _StringValidator.validateString(value, key);
                _StringValidator.validateEmptyString(value, key);
            }
        }
    ]);
    return _StringValidator;
}();
exports.StringValidator = StringValidator;
